export default __webpack_public_path__ + "static/media/info_icon.67611f8e.svg";